export interface ITrafficSalesCreative {
  selectedFormat: string;
  landingPageUrl: string;
  displayAd: {
    uploadedCreative: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    callToAction: string;
    couponCode: string;
  };
  richNotification: {
    uploadedImage: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    description: string;
    callToAction: string;
    couponCode: string;
  };
  videoAd: {
    uploadedVideo: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    callToAction: string;
    couponCode: string;
  };
  smsNotification: {
    storeTargeting: string;
    messageContent: string;
    couponCode: string;
  };
}

export interface IBrandAwarenessCreative {
  selectedFormat: string;
  landingPageUrl: string;
  displayAd: {
    uploadedCreative: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    callToAction: string;
    couponCode: string;
  };
  richNotification: {
    uploadedImage: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    description: string;
    callToAction: string;
    couponCode: string;
  };
  videoAd: {
    uploadedVideo: File | null;
    selectedAssetId?: string;
    selectedAssetName?: string;
    selectedAssetUrl?: string;
    headline: string;
    callToAction: string;
    couponCode: string;
  };
  smsNotification: {
    storeTargeting: string;
    messageContent: string;
    couponCode: string;
  };
}

export enum EObjective {
  TrafficSales = 'traffic-sales',
  BrandAwareness = 'brand-awareness',
}
